import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { ORDER_PROPOSAL_STATUS } from '@/typings/enums/ORDER_PROPOSAL_STATUS';
import { qsTo64 } from '@/utils/tools';
import useOrderTempWorkerProposalService from '@/services/order/OrderTempWorkerProposalService';

type Props = SetupProps<typeof DashboardPendingJobOfferCardSetupService.props>

export default class DashboardPendingJobOfferCardSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({
		countWaiting: 0,
		dataLoaded: false,
	});

	get countWaiting () { return this.state.countWaiting; }
	get dataLoaded () { return this.state.dataLoaded; }

	constructor (props?: Props) {
		super(props);
	}

	protected async onBeforeMountAsync () {
		this.state.countWaiting = await useOrderTempWorkerProposalService().countWaitingAsync();
		this.state.dataLoaded = true;
	}

	gotToJobOffers (status: ORDER_PROPOSAL_STATUS) {
		this.router.push({
			name: 'JobOffer',
			query: { filter: qsTo64({ status }) },
		});
	}
}
